import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';

import { Grid, Box, Typography } from '@mui/material';

import StatusTag from '../atoms/StatusTag';
import InfoToolTip from '../atoms/InfoToolTip';

import { getTranslationValueFromKey } from '../../../utils/helpers';
import { displayImageStorageForRegion } from '../../../utils/configurationHelpers';
import {
  PENDING_ACTION,
  IMAGES_STORED,
  AWAITING_RESULT,
  REPORT_READY,
  STATUSES_DESCR,
  PENDING_REVIEW,
  AUDIOLOGIST,
  RECORD_PENDING,
  RECORD_STORED,
  AUDIO_RECORD_STATUSES_DESCR,
} from '../../../constants/constants';
import { InfoIcon } from '../../../resources/icons';

const ToolTipItem = ({ status, description }) => {
  return (
    <Grid container key={status} wrap={'nowrap'} alignItems={'center'}>
      <Grid item xs={4.5}>
        <StatusTag small status={status} />
      </Grid>
      <Grid item xs={7.5}>
        <Typography fontSize={12} ml={1}>
          {description}
        </Typography>
      </Grid>
    </Grid>
  );
};

const ResultsToolTip = (props) => {
  const staticWords = useSelector((state) => state.handlingTranslation.words);
  const displayImageStorage = displayImageStorageForRegion();
  const { user } = props;
  const [statusDescriptions, setStatusDescriptions] = useState([]);
  useEffect(() => {
    if (user?.role === AUDIOLOGIST) {
      return setStatusDescriptions([RECORD_PENDING, RECORD_STORED]);
    }
    setStatusDescriptions([PENDING_ACTION, IMAGES_STORED, AWAITING_RESULT, PENDING_REVIEW, REPORT_READY]);
  }, [user?.role]);
  return (
    <InfoToolTip
      content={
        <Grid container display="flex" direction="column" pt={1} gap={1}>
          {statusDescriptions
            .filter((el) => {
              // only display Image Stored status for specific regions (DE)
              return displayImageStorage ? true : el !== IMAGES_STORED;
            })
            .map((status, index) => {
              return (
                <ToolTipItem
                  key={index}
                  status={status}
                  description={
                    user?.role === AUDIOLOGIST
                      ? staticWords[getTranslationValueFromKey(AUDIO_RECORD_STATUSES_DESCR[status])]
                      : staticWords[getTranslationValueFromKey(STATUSES_DESCR[status])]
                  }
                />
              );
            })}
        </Grid>
      }
      sx={{ display: 'flex', alignItems: 'center' }}
      maxWidth="400px"
    >
      <Box component="div">
        <InfoIcon width={16} height={16} />
      </Box>
    </InfoToolTip>
  );
};
const mapStateToProps = (state) => ({
  user: state.auth.user,
});
export default connect(mapStateToProps, null)(ResultsToolTip);
